const CLOUDFLARE_EMAIL_TIMEOUT_MS = 10_000

export type CloudflareEmailMessage = {
  to: string
  from: string
  subject: string
  html: string
  text: string
  attachments?: {
    content: string
    filename: string
    type: string
    disposition: 'attachment'
  }[]
}

export function escapeHtml(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;')
}

export async function sendCloudflareEmail(message: CloudflareEmailMessage) {
  const accountId = process.env.CLOUDFLARE_ACCOUNT_ID
  const apiToken = process.env.CLOUDFLARE_EMAIL_API_TOKEN

  if (!accountId || !apiToken) {
    throw new Error('Cloudflare Email Service is niet geconfigureerd.')
  }

  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), CLOUDFLARE_EMAIL_TIMEOUT_MS)

  let response: Response
  try {
    response = await fetch(
      `https://api.cloudflare.com/client/v4/accounts/${accountId}/email/sending/send`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${apiToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message),
        signal: controller.signal,
      },
    )
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error('Cloudflare Email Service timeout.')
    }

    throw error
  } finally {
    clearTimeout(timeout)
  }

  if (!response.ok) {
    const body = await response.text().catch(() => '')
    throw new Error(
      `Cloudflare Email Service fout (${response.status}): ${body || response.statusText}`,
    )
  }

  const result = await response.json().catch(() => null)

  if (result && result.success === false) {
    throw new Error(`Cloudflare Email Service fout: ${JSON.stringify(result.errors ?? [])}`)
  }

  return result
}
